export default {
  gutterBottom: {
    marginBottom: 10
  }
};
